// Must be the first import
// eslint-disable-next-line no-undef
if (process.env.NODE_ENV === 'development') {
  // Must use require here as import statements are only allowed
  // to exist at top-level.
  import('preact/debug');
}
import 'pixi.js/unsafe-eval';
import { render } from 'preact';
import { App } from './App.jsx';
import './index.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

render(<App />, document.getElementById('app'));
